import moment from 'moment';

enum FLOW_BUILDER_EMAIL_PARAMS {
  CurrentEpoch = 'currentEpoch',
  LogoImgUrl = 'logoImgUrl',
  NotableLogoUrl = 'notableLogoUrl',
  ThemeButtonBackground = 'themeButtonBackground',
  UnsubscribeUrl = 'unsubscribeUrl',
}

export function getSendEmailBlockVariables(): Record<FLOW_BUILDER_EMAIL_PARAMS, string> {
  return {
    currentEpoch: moment().unix().toString(),
    logoImgUrl: 'https://app.notablehealth.com/asset/previsit/demo-logo.png',
    notableLogoUrl: 'https://app.notablehealth.com/asset/previsit/powered-by-notable-logo-2024.png',
    themeButtonBackground: 'blue',
    unsubscribeUrl: 'https://checkin.pcmahealth.org/previsit/app/#/unsubscribe/1234',
  };
}

export const SEND_EMAIL_BLOCK_BASE_CONTENT = `<html>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html, body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        line-height: 1.5rem;
      }
    </style>
  </head>
  <body>
    <div style="background-color: rgb(236, 240, 243);padding: 2rem;">
      <div style="padding-top: 2.5rem;margin: auto; background-color: white;max-width: 400px;">
        <div style="margin: auto;text-align: center;" class="practice-logo">
          <img src="{{logoImgUrl}}" height="51" />
        </div>
        <div style="padding: 2rem 3.5rem 2.5rem;">
          <p>
            For your safety, we request you complete the following intake before your visit. This should take less than 2 mins to complete.
            <br />
          </p>
          <p>
            <a
              href="{{data.url}}"
              target="_blank"
              class="cta-button theme-button"
              style="display: block;
              border-radius: 0.25rem;
              color: white !important;
              background-color: {{themeButtonBackground}};
              text-decoration: none;
              padding: 0.6rem;
              text-align: center;
              margin-top: 2.5rem;"
            >
              Start now
            </a>
          </p>
        </div>
      </div>
      <div class="notable-logo" style="margin: 2rem auto;text-align: center;color: #777;">
        <img
          src="{{notableLogoUrl}}"
          width="80"
          height="32"
        />
      </div>
    </div>
    <div style="font-size: 0.7rem;margin: 2.5rem; text-align: center;">
      <a style="color:#adafaf" href="{{unsubscribeUrl}}">
        Unsubscribe ({{data.email}})
      </a>
    </div>
    <div style="opacity: 0">{{currentEpoch}}</div>
  </body>
</html>`;
